import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { storage } from "../../../../../Firebase/config";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import html2canvas from "html2canvas";
import { Modal } from "reactstrap";
import PopupContractPrivacyPolicy from "../../../../Common/PopupContractPrivacyPolicy";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import { awardContest } from "../../../../../redux/contest/action";
import { takeAndUploadScreenshot } from "../../../../../utils/takeAndUploadScreenshot";
import SignContractInput from "../../../../Common/SignContractInput";

const SignContestContract = ({ pbi }) => {
  const { setManageAppliedprojectroute } = useRouteBaseStateContext();

  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const { state } = location;
  const [modal, setModal] = useState(null);

  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const formik = useFormik({
    initialValues: {
      first_name: profile?.first_name,
      last_name: profile?.last_name,
      agree: false,
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("First name is required"),
      last_name: Yup.string().required("Last name is required"),
      agree: Yup.boolean().oneOf([true], "You must agree to the terms"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
                // const screenshotUrl = await takeAndUploadScreenshot();
        const screenshotUrl = "image.png"

        if (screenshotUrl) {
          hireexpert(screenshotUrl, values);
        } else {
          setLoading(false);
          console.error("Failed to upload screenshot. Please try again.");
        }
      } catch (error) {
        console.error("Error taking or uploading screenshot:", error);
        setLoading(false);
      }
    },
  });


  const hireexpert = (screenshotUrl, values) => {
    const data = {
      ...values,
      id: pbi?.id,
      image: screenshotUrl,
      type: 2,
      status: 12,
    };
    dispatch(awardContest(data, setLoading));
    navigate(-1)
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <SignContractInput formik={formik} />

        <div className="checkbox">
          <input
            type="checkbox"
            id="agree"
            name="agree"
            checked={formik.values.agree}
            onClick={() => {
              if (!formik.values.agree) {
                setModal(true);
              }
              else {
                formik.setFieldValue("agree", !formik.values.agree);
              }
            }}
          />
          <label htmlFor="agree">
            Yes, I understand and agree to Urxprt’s {' '}
            <span>{' '} Terms of Service</span>, including the
            <span>{' '} User Agreement</span> and <span>Privacy Policy</span>.
          </label>
          {formik.touched.agree && formik.errors.agree ? (
            <div className="error">{formik.errors.agree}</div>
          ) : null}
        </div>

        <div className="submit-btn">
          <button type="submit" className="btn post-btn" disabled={loading}>
            {loading
              ? "Submitting..."
              : state?.approvefrom
                ? "Accept & Start project"
                : "Accept and Award Winner"}
          </button>
        </div>
      </form>
      {modal && (
        <Modal
          isOpen={modal}
          keyboard={false}
          className="modal-width modal-centered popupmodal termsconditionmodal"
           modalClassName="ter-over"
        >
          <PopupContractPrivacyPolicy formik={formik} setModal={setModal} />
        </Modal>
      )}
    </>
  );
};

export default SignContestContract;
